/**
 * 时时彩，通用模板，1分彩，2分彩，5分彩 投注选择区
 */
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import Loader from '../../../components/icon/Loader.jsx';
import * as Rules from '../../../constants/lotterys/rules/rulesEntry'

import $$CACHE from '../../../helpers/cache'

import SelectModes from './SelectModes.jsx'
import SelectTimes from './SelectTimes.jsx'
import SelectPosition from './SelectPosition.jsx'
import AddBets from './AddBets.jsx'

import BetDigital from './bet/Bet_Digital.jsx'
import BetInput from './bet/Bet_Input.jsx'
import BetDxDs from './bet/Bet_DxDs.jsx'
import BetPK from './bet/Bet_PK.jsx'
import BetDice from './bet/Bet_Dice.jsx'
import BetDiceSame from './bet/Bet_DiceSame.jsx'
import BetBox from './bet/Bet_Box.jsx'
import MissHotCode from '../../../components/button/MissHotCold.jsx'

import { DRAW_WEB } from '../../../constants/config'
import { ACTIVE_MISSING_FN_METHOD, SHORTCUT_ENTRANCE } from '../../../constants/lotterys/config'


class LotterySsc extends React.Component {

  constructor(props) {
    super(props);
    this.updateCurrentMethods = this.updateCurrentMethods.bind(this);
    this.setCurrentCategoryMethod = this.setCurrentCategoryMethod.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleMethodClick = this.handleMethodClick.bind(this);
    this.handleBetCodeClick = this.handleBetCodeClick.bind(this);
    this.handleChangeModes = this.handleChangeModes.bind(this);
    this.handleChangeTimes = this.handleChangeTimes.bind(this);
    this.handleChangePosition = this.handleChangePosition.bind(this);
    this.setCurrentBetExtend = this.setCurrentBetExtend.bind(this);
    this.handleChangePrizeMode = this.handleChangePrizeMode.bind(this);
    this.switchMissHotTypes = this.switchMissHotTypes.bind(this);
    this.addOrder = this.addOrder.bind(this);
    this.state = {
      currentCategory: {},
      currentMethod: {},
      currentBet: {},
      missHot: {}
    }
  }

  componentDidMount() {
    this.updateCurrentMethods(this.props)
  }

  componentWillReceiveProps(nextProps) {
    return this.updateCurrentMethods(nextProps)
  }

  // 添加投注
  addOrder(betDirect) {
    const { submit, display } = this.state.currentBet;
    const { windowId } = this.props;
    const __methods = this.props.__METHOD.toJS();
    // 投注是0则返回
    if (this.state.currentBet.display.num == 0) { return; }
    if (!betDirect) {
      // 投注有相同的话返回
      if (_.find(__methods.windows[windowId].submit, { codes: submit.codes, menuid: this.state.currentMethod.menuid, poschoose: submit.poschoose })) {
        this.props.$$BASE.openAlert('确认区有相同的投注内容');
        return;
      }
      // 显示错误（过滤）信息
      if (this.state.currentBet.message.length > 0) {
        const message = _.chain(this.state.currentBet.message).map(function(item){
          return '<h4>' + item + '</h4>';
        }).join('').value();
        this.props.$$BASE.openAlert(message);
      }
      // 如果是单式，清空单式的填写区
      if (this.state.currentMethod.selectarea.type === 'input') {
        document.getElementById('bet-input-codearea').value = '';
      }
      // 重置数据
      this.setState({
        currentBet: lotteryService.initBetData(this.state.currentMethod, this.state.currentBet,this.props.params.lotteryFlag)
      })

      this.props.$$LOTTERY.addOrder(submit, display, windowId, this.state.currentMethod.id)
      return;
    }
    // 如果是单式，清空单式的填写区
    if (this.state.currentMethod.selectarea.type === 'input') {
      document.getElementById('bet-input-codearea').value = '';
    }
    // 重置数据
    this.setState({
      currentBet: lotteryService.initBetData(this.state.currentMethod, this.state.currentBet,this.props.params.lotteryFlag)
    })
    const mmcPlayTimes = __methods.windows[windowId].times;
    this.props.$$LOTTERY.removeOrder(windowId, null);
    this.props.$$LOTTERY.mmcPlayTimes(windowId, mmcPlayTimes);
    this.props.$$LOTTERY.addOrder(submit, display, windowId, this.state.currentMethod.id)
    _.delay(this.props.submit.bind(this, true), 200)
  }

  // 设置当前注数和投注额
  setCurrentBetExtend(result) {
    let _currentBet = _.cloneDeep(this.state.currentBet);
    _currentBet.display = result.display;
    _currentBet.submit = result.submit;
    _currentBet.message = result.message;
    this.setState({
      currentBet: _currentBet
    })
  }

  // 设置当前投注模式： 元角分
  handleChangeModes(mode) {
    if (mode == this.state.currentBet.mode) {
      return;
    }
    let _currentBet = _.cloneDeep(this.state.currentBet);
    _currentBet.mode = mode;
    this.setState({
      currentBet: _currentBet
    })
     // 玩法偏好（圆角分模式）
    lotteryService.storeMethodsPreference(this.state.currentMethod.menuid, 'mode', mode);
    Rules.execute(this.state.currentCategory, this.state.currentMethod, _currentBet, this.setCurrentBetExtend, 'ssc');
  }

  // 设置当前投注位置(万位，千位等)
  handleChangePosition(poschoose) {
    let _currentBet = _.cloneDeep(this.state.currentBet);
    _currentBet.poschoose = poschoose;
    this.setState({
      currentBet: _currentBet
    })
     // 玩法偏好（任选位置）
    lotteryService.storeMethodsPreference(this.state.currentMethod.menuid, 'poschoose', poschoose);
    Rules.execute(this.state.currentCategory, this.state.currentMethod, _currentBet, this.setCurrentBetExtend, 'ssc');
  }

  // 设置当前投注单注奖金
  handleChangePrizeMode(prize) {
    let _currentBet = _.cloneDeep(this.state.currentBet);
    _currentBet.prize = prize;
    this.setState({
      currentBet: _currentBet
    })
    Rules.execute(this.state.currentCategory, this.state.currentMethod, _currentBet, this.setCurrentBetExtend, 'ssc');
  }

  // 设置倍数
  handleChangeTimes(times) {
    let _currentBet = _.cloneDeep(this.state.currentBet);
    _currentBet.times = times;
    this.setState({
      currentBet: _currentBet
    })
    Rules.execute(this.state.currentCategory, this.state.currentMethod, _currentBet, this.setCurrentBetExtend, 'ssc');
  }

  // 切换彩种类型
  handleTabClick(categoryName) {
    if (categoryName == this.state.currentCategory.name) { return; }
    this.setCurrentCategoryMethod(window.METHODS, this.props, categoryName)
  }

  // 切换玩法
  handleMethodClick(menuId) {
    if (menuId === this.state.currentMethod.menuid) { return; }
    let currentMethod = lotteryService.setCurrentMethod(this.state.currentCategory, menuId)
    //无权限
    if (!currentMethod) {
      return this.props.$$BASE.openAlert('请联系上级开通该玩法');
    }
    // 回传当前玩法
    this.props.updateCurrentMethod(currentMethod, this.state.currentCategory)
    this.setState({
      currentMethod: currentMethod,
      currentBet: lotteryService.initBetData(currentMethod, this.state.currentBet,this.props.params.lotteryFlag),
      missHot: { type: 1, subType: 0 }
    })
  }

  // 设置当前选中的类型和方法
  setCurrentCategoryMethod(methods, props, categoryName = null, menuid = null) { 
    let currentCategory = lotteryService.setCurrentCategory(methods, props.params.lotteryFlag, props.params.methodType, categoryName)
    // 没有彩种权限
    if (!currentCategory) {
      this.props.$$BASE.openAlert('请联系上级开通该彩种');
      return window.location.href = '#'
    }
    let menuidFlag; //重置menuid
    if(currentCategory.close){
      menuidFlag = currentCategory.categories[0].methods[0].menuid;
    }
    menuid = menuidFlag ? menuidFlag : menuid;

    let currentMethod = lotteryService.setCurrentMethod(currentCategory, menuid)
    //没有玩法权限
    if (!currentMethod) {
      return this.props.$$LOTTERY.setLotteryErrors({message: '请联系上级开通该玩法'}, {extend: this.props.windowId, lotteryId: window.METHODS.windows[this.props.windowId].id})        
    }
    // 回传当前玩法
    this.props.updateCurrentMethod(currentMethod, currentCategory)
    // 重新读取上一次的奖金组和模式
    const resetMode = menuid ? true : false;
    this.setState({
      currentCategory: currentCategory,
      currentMethod: currentMethod,
      currentBet: lotteryService.initBetData(currentMethod, this.state.currentBet, this.props.params.lotteryFlag),
      missHot: { type: 1, subType: 0 }
    })
  }

  // 选号
  handleBetCodeClick(codes, index) {
    let _currentBet = _.cloneDeep(this.state.currentBet);
    // 单行变更
    if (!_.isUndefined(index)) {
      _currentBet.codes[index] = codes;
    } else {
      _currentBet.codes = codes;
    }
    // 最多个数选择检查
    const currentMethod = this.state.currentMethod;
    if (currentMethod.selectarea && currentMethod.selectarea.type=='digital' && currentMethod.maxcodecount > 0) {
      const count = _.chain(_currentBet.codes).map((item) => item.length).sum().value();
      if (count > currentMethod.maxcodecount) {
        return this.props.$$BASE.openAlert('最多可选择 '+currentMethod.maxcodecount+' 个号码')
      }
    }
    this.setState({
      currentBet: _currentBet
    })
    Rules.execute(this.state.currentCategory, this.state.currentMethod, _currentBet, this.setCurrentBetExtend, 'ssc');
  }


  // 切换彩种，或者第一次加载完成动态区时设置当前玩法
  updateCurrentMethods(props) {

    const __methods = props.__METHOD.toJS();
    const windowId = props.windowId;

    // 首先判断动态和静态数据是否已经完成加载
    if (!__methods.staticLoadDone || !__methods.dynamicLoadDone) {
      return;
    }

    if (_.intersection(_.split(window.location.hash, '/'), ['animate', 'ssc']).length == 0) {
      return;
    }

    // 判断当前区是否和路由中的lotteryFlag一致，如果一致继续
    if (__methods.windows[windowId] &&
      __methods.windows[windowId].flag == props.params.lotteryFlag) {
      // 若只是类型变更则重新设置选中
      if (this.props.params.methodType != props.params.methodType) {
        // 如果是由玩法记忆自动跳转的URI，那么忽略重置
        let storeMethods = $$CACHE.get('METHOD_MEMORY_' + window.userId);
        storeMethods = storeMethods ? storeMethods.data : [];
        const method = _.find(storeMethods, {alias: props.params.lotteryFlag});
        if (method && _.chain(method.hash).split('/').last().value() == props.params.methodType) {
          return;
        }
        this.setCurrentCategoryMethod(window.METHODS, props);
      }
      // 若变更了彩种
      if (this.props.params.lotteryFlag != props.params.lotteryFlag || _.isEmpty(this.state.currentCategory)) {
        // 还原记忆的玩法
        let storeMethods = $$CACHE.get('METHOD_MEMORY_' + window.userId);
        storeMethods = storeMethods ? storeMethods.data : [];
        const method = _.find(storeMethods, {alias: props.params.lotteryFlag});
        const categoryName = method ? method.category : null;
        const menuid = method ? method.menuid : null;
        this.setCurrentCategoryMethod(window.METHODS, props, categoryName, menuid);
      }
    }

    this.props.updateCurrentMethod(this.state.currentMethod, this.state.currentCategory);

  }

  // 切换冷热遗漏类型
  switchMissHotTypes(type, isSub = false) {
    if (isSub) {
      this.setState({
        missHot: {
          type: this.state.missHot.type,
          subType: type
        }
      })
      return;
    }
    this.setState({
      missHot: {
        type: type,
        subType: 1
      }
    })
  }
  handlePrizeChange(){
      const prize = ReactDOM.findDOMNode(this.refs.prize).value;
      this.handleChangePrizeMode(prize);
  }

  render() {
    const windowId = this.props.windowId;
    const __window = this.props.__METHOD.toJS().windows[windowId];
    const params = this.props.params;
    const submit = this.props.submit;
    const { currentCategory, currentMethod, currentBet, showSelectMehtodBox } = this.state;
    let missHotCodes = null;
    // 冷热遗漏号码
    if (this.state.missHot.subType != 0 && __window.missCodes) {
      // 遗漏
      if (this.state.missHot.type == 1) {
        switch (this.state.missHot.subType) {
          case 1: missHotCodes = __window.missCodes.miss_current; break;
          case 2: missHotCodes = __window.missCodes.miss_max; break;
        }
      }
      // 冷热
      if (this.state.missHot.type == 2) {
        switch (this.state.missHot.subType) {
          case 1: missHotCodes = __window.missCodes._30; break;
          case 2: missHotCodes = __window.missCodes._50; break;
          case 3: missHotCodes = __window.missCodes._100; break;
        }
      }
    }

    return (
      <div className='fl ssc-select-area'>
        {
          // 未完成当前彩种设置前显示LOADING
          !__window || params.lotteryFlag != __window.flag || _.isEmpty(this.state.currentMethod) ?
            <Loader /> :
            <div className='lotteryLeft'>
              <SelectTabBox
                flag={__window.flag}
                missCodes={__window.missCodes}
                methodType={this.props.params.methodType}
                currentMethod={currentMethod}
                currentCategory={currentCategory}
                currentBet={currentBet}
                handleTabClick={this.handleTabClick}
                handleMethodClick={this.handleMethodClick}
                handleChangePosition={this.handleChangePosition}
                handleChangePrizeMode={this.handleChangePrizeMode}
                missHot={this.state.missHot} 
                switchMissHotTypes={this.switchMissHotTypes}
              />
              <SelectCodeBox 
                currentMethod={currentMethod}
                currentCategory={currentCategory}
                currentBet={currentBet}
                handleBetCodeClick={this.handleBetCodeClick}
                openAlert={this.props.$$BASE.openAlert}
                missCodes={missHotCodes}
                missCodeType={this.state.missHot.type}
              />
              <div className={this.props.params.lotteryFlag === 'mmc' ? 'addOrderBox' : 'addOrderBox'}>
                <div className="currentBet">
                  <p>已选 <span >{this.state.currentBet.display.num}</span> 注</p>
                  <p>共 <span className='money'>{_.round(this.state.currentBet.display.money, 3).toFixed(3)}</span> 元</p>
                  <br className="clearfix" />
                </div>
                  <AddBets
                      currentNum={this.state.currentBet.display.num}
                      currentMoney={this.state.currentBet.display.money}
                      addFn={this.addOrder}
                      windowId={windowId}
                      submit={submit}
                      openTrack={this.props.openTrack}
                      params={this.props.params}
                  />
                {
                    // 奖金组
                    currentMethod && currentMethod.prize && currentMethod.prize.length > 0 ?
                        <div className="fandian">
                            <select
                                ref='prize'
                                value={currentBet.prize}
                                onChange={() => this.handlePrizeChange()}
                            >
                                {
                                    currentMethod.prize.map((item, index) =>
                                        <option key={index} value={item.value} >{item.label}</option>
                                    )
                                }
                            </select>
                        </div> : null
                }
                <SelectModes
                    modes={this.state.currentMethod.modes}
                    value={this.state.currentBet.mode.rate}
                    onChange={this.handleChangeModes}
                    ismmc={this.props.params.lotteryFlag === 'mmc' ? true : false}
                />
              <SelectTimes
                value={this.state.currentBet.times}
                onChange={this.handleChangeTimes}
                text='倍'
              />
              </div>
            </div>
        }
      </div>
    );
  }
}

reactMixin(LotterySsc.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __METHOD: state.method,
    __BASE: state.base
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LotterySsc)



// 选号位置组件分发
class SelectCodeBox extends React.Component {

  constructor(props) {
    super(props);
    this.makeSscSelectCodes = this.makeSscSelectCodes.bind(this);
  }

 /**
 * 生成时时彩种选号区
 * @return {[type]} [description]
 */
  makeSscSelectCodes() {
    const {currentMethod, currentCategory, currentBet, handleBetCodeClick, missCodes, missCodeType, openAlert } = this.props;
    // 遗漏位数对应表
    const missCodeTextMap = ['万位','千位','百位','十位','个位'];
    // 数字型
    if (currentMethod.selectarea.type == 'digital' && currentMethod.selectarea.layout) {
      return currentMethod.selectarea.layout.map((item, index) => {
        return <BetDigital
          key={index}
          index={index}
          className={currentMethod.selectarea.className || null}
          values={currentBet.codes[index]}
          items={item.no}
          title={item.title}
          onChange={handleBetCodeClick}
          showButton={currentMethod.selectarea.isButton} 
          missCodes={missCodes ? missCodes[_.indexOf(missCodeTextMap, item.title)] : null} 
          missCodeType={missCodeType} 
          pos={currentMethod.show_str.split(',')[index]}
        />
      })
    }
    // 输入型，单式
    if (currentMethod.selectarea.type == 'input') {
      return <BetInput
        onChange={handleBetCodeClick}
        methodId={currentMethod.methodid} 
        bet={currentBet} 
        category={currentCategory} 
        method={currentMethod} 
        baseAlert={openAlert} 
      />
    }
    // 大小单双
    if (currentMethod.selectarea.type == 'dxds' && currentMethod.selectarea.layout) {
      return currentMethod.selectarea.layout.map((item, index) => {
        return <BetDxDs
          key={index}
          index={index}
          values={currentBet.codes[index]}
          items={item.no}
          title={item.title}
          onChange={handleBetCodeClick}
          showButton={currentMethod.selectarea.isButton}
        />
      })
    }
    // 对决 PK
    if (currentMethod.selectarea.type == 'pk') {
      return <BetPK
        className={currentMethod.selectarea.className}
        values={currentBet.codes}
        onChange={handleBetCodeClick}
      />
    }
    // 普通和互斥骰子
    if (currentMethod.selectarea.type == 'dice' || currentMethod.selectarea.type == 'dice_relation') {
      return <BetDice
        values={currentBet.codes}
        items={currentMethod.selectarea.layout}
        type={currentMethod.selectarea.type}
        onChange={handleBetCodeClick}
      />
    }
    // 全选骰子
    if (currentMethod.selectarea.type == 'dice_all') {
      return <BetDiceSame
        values={currentBet.codes}
        items={currentMethod.selectarea.layout}
        onChange={handleBetCodeClick}
        mname={currentMethod.name}
      />
    }
    // 快乐8，盒子项
    if (currentMethod.selectarea.type == 'box') {
      return <BetBox
        items={currentMethod.selectarea.layout[0].no}
        onChange={handleBetCodeClick}
        values={currentBet.codes}
      />

    }
  }

  render() {
    return (
      <div className='lotteryView'>
        {
          this.makeSscSelectCodes()
        }
      </div>
    );
  }

}



// 玩法选择区
class SelectTabBox extends React.Component {

  constructor(props) {
    super(props);
    this.makeSscSelectTab = this.makeSscSelectTab.bind(this)
  }

 /**
 * 生成时时彩种选号区
 * @return {[type]} [description]
 */
  makeSscSelectTab() {
    const {
      methodType, currentMethod, currentCategory, currentBet, flag, missCodes,
      handleTabClick, handleMethodClick, handleChangePosition, handleChangePrizeMode,
      missHot, switchMissHotTypes
    } = this.props;
    // 常规玩法和特殊玩法
    let uri = '#/lottery/ssc/' + flag + '/';
    uri += methodType == 'ts' ? 'cg' : 'ts';
    let current = {};
    current.static = window.METHODS.static[flag];
    // 冷热遗漏加载完成
    let missCodeReady = false;

    if (_.includes(ACTIVE_MISSING_FN_METHOD[flag], currentMethod.menuid) && missCodes) {
      missCodeReady = true;
    }
    return <div>
      <div className={!current.static.needFilter ?'noBtn lotteryGroup ' + flag :'lotteryGroup ' + flag}>
        <ul>
          {
            // 分类菜单
            current.static.data_label.map((item, index) =>
              methodType == item.type || !item.type ?
                <li
                  key={index}
                  onClick={() => handleTabClick(item.title)}
                  className={item.title == currentCategory.name ? 'hover' : null}>
                  {item.title}
                  {item.isnew === '1' ? <em /> : null}
                </li> : null,
            )
          }
        </ul>
        {
          // 切换常规玩法和特殊玩法
          current.static.needFilter ?
            <div className="ren">
              <a href={uri}>{methodType == 'ts' ? "常规玩法" : "特殊玩法"}</a>
            </div> : null
        }
      </div>
      <div className='lotteryMember relative'>
        {
          // 子菜单
          currentCategory ?
            currentCategory.categories.map((category, index) =>
              <dl className='cWay' key={index} >
                <dt>{category.title}</dt>
                {
                  category.methods.map((method, idx) =>
                    <dd
                      key={idx}
                      onClick={() => handleMethodClick(method.menuid)}
                      className={
                        currentMethod.menuid == method.menuid ? 'hover' : null
                      }>{method.desc}</dd>
                  )
                }
              </dl>
            ) : null
        }
        {
          // 选择位置区
          currentMethod.selectarea.selPosition ?
            <SelectPosition onChange={handleChangePosition} value={currentBet.poschoose} pos={currentMethod.defaultposition} /> : <dl></dl>
        }
      </div>
      <div className="cf">
        {
          missCodeReady ? 
            <MissHotCode type={missHot.type} subType={missHot.subType} handleChange={switchMissHotTypes}/>: null
        }
        {
          SHORTCUT_ENTRANCE[flag] &&
          SHORTCUT_ENTRANCE[flag].map((item, i) => {
            return (
                <a href={item.link} key={i} className="shortcut-link">{item.lable}</a>
            )
          })
        }
        <div className='playf_dl fr'>
          <span className="wfsm">
            <i className="icon_sm"></i>
            说明
            <div
              className='desc-panel'
              dangerouslySetInnerHTML={{ __html: currentMethod.methoddesc }}
            />
          </span>
          {
            currentMethod.methodexample ? 
              <span className="help_exp">
                <i className="icon_sl"></i>
                示例
                <div
                  className='desc-panel'
                  dangerouslySetInnerHTML={{ __html: currentMethod.methodexample }}
                />
              </span> : null
          }
          <span className="help_help">
            <i className="icon_bz"></i>
            帮助
            <div
              className='desc-panel'
              dangerouslySetInnerHTML={{ __html: currentMethod.methodhelp }}
            />
          </span>
          {
            DRAW_WEB[flag] ?
              <a href={DRAW_WEB[flag]} target="_blank" className="draw_web_f">开奖官网</a> : ''
          }
        </div>
      </div>
    </div>
  }

  render() {
    return (
      <div>
        {
          this.makeSscSelectTab()
        }
      </div>
    );
  }

}